import { ApiClient } from '../../../../../resources/shared/api/client';
import { getEnvRequired } from '../../../../../shared/utilities/env';

export type AT1GenerationResponseData = {
    content: string;
};

interface AT1GenerationJSONAPIResponse {
    data: {
        type: 'agent-first-message-for-dossier';
        id: string;
        attributes: AT1GenerationResponseData;
    };
    jsonapi: {
        version: string;
    };
}

const REQUEST_MANAGER_API_URL = getEnvRequired('REQUEST_MANAGER_API_URL');

const apiClient = new ApiClient(false);

export const fetchAT1Generation = async (
    dossierId: number,
): Promise<AT1GenerationResponseData | null> => {
    const response = await apiClient.get<AT1GenerationJSONAPIResponse>(
        `${REQUEST_MANAGER_API_URL}/discussion/agent-first-message-proposal/${dossierId}`,
    );

    return response.data.attributes;
};
